// 负责商品列表卡片展示，与目录选择状态关联。
import { formatCurrency } from "../../domain/cart";
import type { Product } from "../../domain/products";

type ProductCardProps = {
  product: Product;
  isSelected: boolean;
  onSelect: (product: Product) => void;
};

export const ProductCard = ({
  product,
  isSelected,
  onSelect
}: ProductCardProps) => {
  return (
    <button
      className={isSelected ? "product-card selected" : "product-card"}
      type="button"
      onClick={() => onSelect(product)}
    >
      <img src={product.imageUrl} alt={product.name} />
      <span className="product-meta">{product.category}</span>
      <strong>{product.name}</strong>
      <span>{formatCurrency(product.price)}</span>
    </button>
  );
};
